import { useState, useEffect } from "react";
import { Row, Col, Carousel } from "react-bootstrap";
import { useSelector } from "react-redux";
import {
    CardWrapper, ImageCol, StyledImage, ContentCol, Title, Message, ActionButton,
    DisplayContainer, NavButton
} from "./ThankYouStyle";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { Trans, useTranslation } from "react-i18next";
import Silhoutte from "../../../images/placeholder.svg";
import { useNavigate } from "react-router-dom";
import { encrypt } from "../../../utilities/tokenizer";
import placeholderImage1 from "../../../images/placeholder.svg";
import "../../../styles/Common.css";

const ThankYouDisplay = ({ celebrationProjects, onSeenChildrenChange }) => {

    const { t } = useTranslation();
    const { worldReducer } = useSelector((state) => state);
    const [currentIndex, setCurrentIndex] = useState(0);
    const totalSlides = celebrationProjects.length;
    const [seenChildIds, setSeenChildIds] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const currentChild = celebrationProjects[currentIndex];
        const currentChildId = currentChild?.childCode;
        if (currentChildId && !seenChildIds.includes(currentChildId)) {
            setSeenChildIds((prev) => [...new Set([...prev, currentChildId])]);
        }
    }, [currentIndex, celebrationProjects]);

    useEffect(() => {
        if (typeof onSeenChildrenChange === "function") {
            onSeenChildrenChange(seenChildIds);
        }
    }, [seenChildIds]);

    const handleNext = () => {
        if (currentIndex < totalSlides - 1) {
            setCurrentIndex((prevIndex) => prevIndex + 1);
        }
    };

    const handlePrev = () => {
        if (currentIndex > 0) {
            setCurrentIndex((prevIndex) => prevIndex - 1);
        }
    };

    const isPrevHighlighted = currentIndex > 0;
    const isNextHighlighted = currentIndex < totalSlides - 1;

    const renderCard = (item) => {
        if (!item || !item.childCode) {
            return null;
        }
        const ChildName = item?.childFirstName;
        const ChildImage = item?.childImageURL === "" ? Silhoutte : item?.childImageURL
        const genderCode = item?.genderCode;
        const communityName = item?.community;
        const sponsorName = worldReducer?.getSponsorChildCoordinates?.supporterFName;
        const childCode = encrypt(item?.childCode);

        let genderMessage = "";
        if (genderCode) {
            if (genderCode == "F" || genderCode == "G") {
                genderMessage = t("her");
            } else {
                genderMessage = t("his");
            }
        }
        return (
            <CardWrapper>
                <Row className="w-100 align-items-start mobile-margin-0">
                    <Col xs={12} className="tab_display">
                        <Title>
                            <Trans
                                i18nKey="WorldMapNotificationHeading"
                                values={{ communityName, ChildName }}
                                components={{ boldOrange: <strong style={{ color: "#FF6B00" }} /> }}
                            />
                        </Title>
                    </Col>
                    <ImageCol xs={12} md={4} className="order-2 order-md-1 d-flex justify-content-center align-items-center text-center mb-3 mb-md-0">
                        <div className="w-100 d-flex justify-content-center">
                            <StyledImage onError={addDefaultSrc} src={ChildImage} fluid rounded />
                        </div>
                    </ImageCol>
                    <ContentCol xs={12} md={8} className="order-3 order-md-2 d-flex flex-column">
                        <div className="d-none d-md-block tab-hide">
                            <Title>
                                <Trans
                                    i18nKey="WorldMapNotificationHeading"
                                    values={{ communityName, ChildName }}
                                    components={{ boldOrange: <strong style={{ color: "#FF6B00" }} /> }}
                                />
                            </Title>
                        </div>
                        <Message>
                            <Trans
                                i18nKey="WorldMapNotificationDescription"
                                values={{ sponsorName, genderMessage, communityName, ChildName }}
                                components={{ boldBlack: <strong style={{ color: "black" }} /> }}
                            />
                        </Message>
                        <div className="d-flex align-items-center justify-content-center custom-justify w-100">
                            <ActionButton onClick={() => navigate(`/project-celebration/${childCode}`)}>
                                {t("CelebrateWith", { communityName })}
                            </ActionButton>
                        </div>
                    </ContentCol>
                </Row>
            </CardWrapper>
        );
    };

    const addDefaultSrc = (e) => {
        e.target.src = placeholderImage1;
        e.target.style.height = "auto";
    }

    if (totalSlides === 1) {
        return (
            <DisplayContainer fluid>
                <Row className="justify-content-center w-100">
                    <Col xs={12}>
                        {renderCard(celebrationProjects[currentIndex])}
                    </Col>
                </Row>
            </DisplayContainer>
        );
    }
    
    return (
        <DisplayContainer fluid>
            <>
                <Carousel interval={null}
                    activeIndex={currentIndex}
                    onSelect={(selectedIndex) => setCurrentIndex(selectedIndex)}
                    controls={false}
                    indicators={false}
                >
                    {celebrationProjects.map((item, index) => (
                        <Carousel.Item key={index}>
                            {renderCard(item)}
                        </Carousel.Item>
                    ))}
                </Carousel>
            </>

            <NavButton
                className="left"
                onClick={handlePrev}
                isHighlighted={isPrevHighlighted}
                disabled={!isPrevHighlighted}
            >
                <FaArrowLeft />
            </NavButton>
            <NavButton
                className="right"
                onClick={handleNext}
                isHighlighted={isNextHighlighted}
                disabled={!isNextHighlighted}
            >
                <FaArrowRight />
            </NavButton>
        </DisplayContainer>
    );
};

export default ThankYouDisplay;